export const initialState = {
  featureFlags: {},
}

export default () => ({ ...initialState })
